import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';
import { c as classNames } from '../../../../index-e609ebf3.js';
import '../../../../_commonjsHelpers-17aad09c.js';

var ListElemText = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, forSaving = _a.forSaving, toCapitalize = _a.toCapitalize, toUpperCase = _a.toUpperCase, noTextTransform = _a.noTextTransform, children = _a.children;
    var listElemTextStyles = classNames({
        'saving for-round_loader': forSaving,
        'inner-lists-item-row-item-txt': !forSaving,
        'no-text-transform': noTextTransform,
        'to-uppercase': toUpperCase,
        'to-capitalize': toCapitalize,
    });
    var parsedTitle = title || (typeof children === 'string' || typeof children === 'number' ? children.toString() : '');
    return (React.createElement("p", { className: listElemTextStyles, title: parsedTitle }, children));
};
var ListElemDot = function (_a) {
    var type = _a.type, rest = __rest(_a, ["type"]);
    return React.createElement("div", __assign({ className: "result-circle status-".concat(type) }, rest));
};
var ListElemImage = function (_a) {
    var imageSrc = _a.imageSrc, _b = _a.alt, alt = _b === void 0 ? '' : _b; _a.className; var _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, rest = __rest(_a, ["imageSrc", "alt", "className", "onClick"]);
    var imageClassNames = classNames('list-checked-img', {
        'cursor-p': onClick,
    });
    return React.createElement("img", __assign({ onClick: onClick, className: imageClassNames, alt: alt, src: imageSrc }, rest));
};

export { ListElemDot, ListElemImage, ListElemText };
